export function buildSubmissionEditMetadata(existingSubmission, platform) {
  const rawCreatedVia =
    existingSubmission?.createdVia ||
    existingSubmission?.source ||
    existingSubmission?.devicePlatform ||
    platform;
  const createdVia = rawCreatedVia === "web" ? "web" : "mobile";

  const allowMobileEdit = platform === "mobile" && createdVia !== "web";

  return {
    createdVia,
    source: createdVia,
    lastEditedVia: platform,
    allowMobileEdit,
  };
}

export function buildSubmissionChangeLog({
  previousResponses = {},
  nextResponses = {},
  actor,
  platform,
  formDef = [],
}) {
  const sectionLookup = {};
  const walk = (fields = [], currentSection = null) => {
    fields.forEach((field) => {
      const nextSection = field.type === "section" || field.type === "split_workflow"
        ? field
        : currentSection;
      sectionLookup[field.id] = nextSection
        ? { id: nextSection.id, label: nextSection.label || nextSection.question || nextSection.id }
        : null;

      if (Array.isArray(field.fields)) walk(field.fields, nextSection);
      if (Array.isArray(field.children)) walk(field.children, nextSection);
    });
  };
  walk(formDef);

  const keys = new Set([
    ...Object.keys(previousResponses || {}),
    ...Object.keys(nextResponses || {}),
  ]);

  const actorName = actor?.email || actor?.displayName || actor?.uid || "unknown";
  const changedAt = new Date().toISOString();

  return [...keys].reduce((changes, fieldId) => {
    const oldValue = previousResponses?.[fieldId]?.value;
    const newValue = nextResponses?.[fieldId]?.value;

    if (JSON.stringify(oldValue) === JSON.stringify(newValue)) {
      return changes;
    }

    const section = sectionLookup[fieldId];
    changes.push({
      field: nextResponses?.[fieldId]?.label || previousResponses?.[fieldId]?.label || fieldId,
      fieldId,
      sectionId: section?.id || null,
      sectionLabel: section?.label || null,
      oldValue: oldValue === undefined ? null : oldValue,
      newValue: newValue === undefined ? null : newValue,
      changedBy: actorName,
      changedByUid: actor?.uid || null,
      changedAt,
      platform,
      timestamp: Date.now(),
    });

    return changes;
  }, []);
}
